import { useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export const useAuth = () => {
  const context = useContext(AuthContext);
  const navigate = useNavigate();
  
  if (!context) {
    throw new Error('useAuth debe usarse dentro de un AuthProvider');
  }

  // Función para manejar la redirección después del login
  const handlePostLoginRedirect = useCallback((user, isAdmin = false) => {
    // Verificar si hay una URL de redirección guardada
    const redirectUrl = localStorage.getItem('redirectAfterLogin');
    
    if (redirectUrl && redirectUrl !== '/' && redirectUrl !== '') {
      console.log('Redirigiendo a URL guardada:', redirectUrl);
      localStorage.removeItem('redirectAfterLogin');
      navigate(redirectUrl, { replace: true });
      return;
    }

    // Redirección por defecto basada en el rol
    const role = user?.roleId || user?.rol;
    if (role === 2 && isAdmin) {
      console.log('Redirigiendo a panel de administrador');
      navigate("/admin/main", { replace: true });
    } else {
      console.log('Redirigiendo a cursos');
      navigate("/courses/getCourses", { replace: true });
    }
  }, [navigate]);

  return {
    ...context,
    handlePostLoginRedirect,
  };
};
